<template>
  <header
    :class="headerClass"
    class="header"><!-- nav 활성화 클래스 : nav-active -->
    <div class="header_inner">
      <h1 class="header_title"><router-link :to="{name: 'index', params: {checkBack:true} }">{{ title }}</router-link></h1>
      <!-- <h1 class="header_title">{{ title }}</h1> -->
      <!-- 전체메뉴 -->
      <button
        v-if="!isOpen"
        type="button"
        class="btn_nav"
        @click="isOpen = !isOpen"><span class="blind">전체 메뉴 열기</span><i class="ico_open" /><i class="ico_open" /><i class="ico_open" /></button>
      <button
        v-if="isOpen"
        type="button"
        class="btn_nav"
        @click="isOpen = !isOpen"><span class="blind">전체 메뉴 닫기</span><i class="ico_close" /><i class="ico_close" /></button>
      <!-- // 전체메뉴 -->
      <div class="user_status">
        <!-- 로그인 전-->
        <button v-if="!isLogin" type="button" class="btn_login" @click="moveToLogin"><span class="blind">로그인</span></button>
        <!-- 로그인 후 -->
        <a v-else href="javascript:void(0)" class="btn_mypage" @click="moveMypage" ><span>{{ userName }} 님</span><span class="blind">마이페이지</span></a>
        <button type="button" class="btn_cart" @click="moveCart">
          <span class="blind">장바구니</span>
          <span class="cart_count">{{ cartCnt }}</span><span class="blind">개의 상품이 담겨 있습니다.</span>
        </button>
      </div>
    </div>
    <div :class="{'is-active': isOpen}" class="nav_wrap"><!-- nav 활성화 클래스 : is-active -->
      <div class="nav_header">
        <div class="nav_inner">
          <div class="nav_typo">
            <h2 class="nav_tit"><router-link :to="{ name: 'index', params: {checkBack:true}}">{{ promoInfo.promoNm }}</router-link></h2>
            <!-- 로그인 전-->
            <p v-if="!isLogin" class="nav_txt">
              로그인을 하고<br >
              더 많은 혜택을 이용하세요!
            </p>
            <template v-else>
              <a href="javascript:void(0)" @click="moveMypage" ><span>{{ userName }}</span> 님, 안녕하세요.</a>
              <p class="nav_txt">멀티캠퍼스에 오신것을 환영합니다.</p>
          </template></div>
          <div class="nav_link">
            <a :href="multicampusLink" target="_blank" title="새창열림" class="btn_multi_link">
              <span class="btn_text"><em class="non-kor">Multicampus</em></span>
              <span><em>바로가기</em></span>
            </a>
          </div>
        </div>
      </div>
      <!-- @ 멀티캠퍼스 바로가기 링크 : PC에서만 보여짐 -->

      <nav class="nav_menu_wrap">
        <div class="nav_menu_lists">
          <div class="nav_inner">
            <div v-for="(menuItem, idx) in menuList.menus" :key="idx" :class="{'nav_menu_item--active': menuItem.isActive}" class="nav_menu_item">
              <template v-if="menuItem.menus && menuItem.menus.length > 0">
                <a href="javascript:void(0)" class="depth_title" @click="menuItem.isActive = !menuItem.isActive">
                  <strong class="depth_text">{{ menuItem.menuNm }}</strong>
                  <span class="blind">펼치기</span> <!-- 펼쳐진 상태에서는 해당 텍스트가 '접기'로 변경되어야합니다. -->
                </a>
                <ul v-if="menuItem.menus && menuItem.menus.length > 0" class="nav_menu_list">
                  <li v-for="(subMenuItem, subIdx) in menuItem.menus" :key="subIdx">
                    <a v-if="subMenuItem.menuPathNm && subMenuItem.dmnScCd === 'N'" :href="getLink(subMenuItem)" target="_blank"><span>{{ subMenuItem.menuNm }}</span></a>
                    <a v-else-if="subMenuItem.menuPathNm && subMenuItem.dmnScCd !== 'N'" :href="getLink(subMenuItem)" target="_self"><span>{{ subMenuItem.menuNm }}</span></a>
                    <a v-else href="javascript:void()"><span>{{ subMenuItem.menuNm }}</span></a>
                  </li>
                </ul>
              </template>
              <template v-else>
                <a v-if="menuItem.menuPathNm && menuItem.dmnScCd === 'N'" :href="getLink(menuItem)" class="depth_title" target="_blank">
                  <strong class="depth_text">{{ menuItem.menuNm }}</strong>
                  <span class="blind">펼치기</span> <!-- 펼쳐진 상태에서는 해당 텍스트가 '접기'로 변경되어야합니다. -->
                </a>
                <a v-else-if="menuItem.menuPathNm && menuItem.dmnScCd !== 'N'" :href="getLink(menuItem)" class="depth_title" target="_self">
                  <strong class="depth_text">{{ menuItem.menuNm }}</strong>
                  <span class="blind">펼치기</span> <!-- 펼쳐진 상태에서는 해당 텍스트가 '접기'로 변경되어야합니다. -->
                </a>
                <a v-else href="javascript:void(0)" class="depth_title" @click="menuItem.isActive = !menuItem.isActive">
                  <strong class="depth_text">{{ menuItem.menuNm }}</strong>
                  <span class="blind">펼치기</span> <!-- 펼쳐진 상태에서는 해당 텍스트가 '접기'로 변경되어야합니다. -->
                </a>

              </template>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>

import { forEach, orderBy, find } from 'lodash'

export default {
  name: 'MmpHeader',
  beforeRouteLeave (to, from, next) {
    this.isOpen = false
    next()
  },
  data () {
    return {
      isOpen: false,
      promotionList: [],
      prevYOffset: 300,
      showHeader: true
      // Collapse
    }
  },
  computed: {
    promoInfo () {
      return window.vue.getStore('promoInfo').state.promoInfo
    },
    isLogin () {
      return window.vue.getStore('root').state.session.authenticated
    },
    userName () {
      return window.vue.getStore('root').state.session.mbrFnm
    },
    menuList () {
      return this.promotionList
    },
    cartCnt () {
      return window.vue.getStore('cartInfo').state.cartCnt
    },
    title () {
      // if (this.$route.name === 'index' || this.$route.name === 'PromoDetail') {
      return this.promoInfo.promoNm
      // } else {
      // return this.$route.meta.title
      // }
    },
    multicampusLink () {
      if (this.$utils.userAgent.isDesktop()) {
        return 'https://www.multicampus.com/main'
      } else {
        return 'https://www.multicampus.com/em/enrolment/courseDetaiInfo/mobileServicePopup'
      }
    },
    headerClass () {
      return {
        'nav-active': this.isOpen
        // 'header-show': !this.isOpen && this.showHeader,
        // 'header-hide': !this.isOpen && !this.showHeader
      }
    }
  },
  watch: {
    'isOpen': {
      handler: function (nVal, oVal) {
        if (this.isOpen) {
          document.body.classList.add('overflow')
          document.querySelector('.btn_nav').dataset.effectExecute = true
        } else {
          document.body.classList.remove('overflow')
          delete document.querySelector('.btn_nav').dataset.effectExecute
        }
      }
    },
    'isLogin': {
      handler: function (nVal, oVal) {
        window.vue.getStore('cartInfo').dispatch('updateCartCnt')
      }
    }
  },
  mounted () {
    this.getPromotionList()
    // if (window.addEventListener ) {
    //   window.addEventListener('scroll', this.headerEvents)
    // } else {
    //   window.attachEvent('onscroll', this.headerEvents)
    // }
  },
  beforeDestroy () {
    // if (window.addEventListener ) {
    //   window.removeEventListener('scroll', this.headerEvents)
    // } else {
    //   window.detachEvent('onscroll', this.headerEvents)
    // }
  },
  created () {
    window.vue.getStore('cartInfo').dispatch('updateCartCnt')
  },
  beforeUpdate () {
  },
  methods: {
    // headerEvents (e) {
    //   const { pageYOffset } = window
    //   if (pageYOffset > this.prevYOffset) {
    //     this.showHeader = false
    //   } else {
    //     this.showHeader = true
    //   }

    //   this.prevYOffset = pageYOffset
    // },
    getLink (menuItem) {
      return window.location.protocol + '//' + menuItem.menuPathNm
    },
    moveToLogin () {
      this.isOpen = false
      this.$goPage({name: 'Login'})
    },
    moveCart () {
      this.$goPage({'name': 'Cart'})
      this.isOpen = false
    },
    moveMypage () {
      this.$goPage({'name': 'MypageInfo'})
      this.isOpen = false
    },
    async getPromotionList () {
      try {
        var listPromoResult = await this.$http.mmp.listPromo(this, {})
        this.promotionList = this.makeTree(listPromoResult.data.data.resultData)
        console.log(this.promotionList)
      } catch (err) {
        console.log(err)
      }
    },
    makeTree (listData) {
      if (listData === null || listData.length < 1) {
        return {
          menus: []
        }
      }
      const treeObj = {
        menus: []
      }

      forEach(orderBy(listData, ['menuDepth'], ['asc']), function (val, idx) {
        if (val.menuDepth === 1) {
          this.$set(val, 'isActive', idx === 0)
          treeObj.menus.push(val)
        } else {
          const parentMenu = find(listData, { menuDepth: 1, bMenuId: val.aMenuId })

          if (parentMenu !== undefined) {
            if (parentMenu.menus === undefined) {
              parentMenu.menus = []
            }
            parentMenu.menus.push(val)
          }
        }
      }.bind(this))

      return treeObj
    }
  }
}

</script>

<style scoped>
.header-hide {
  transition:350ms transform ease;transform:translateY(-100%)
}
.header-show {
  transition:350ms transform ease;transform:translateY(0%)
}

</style>



// WEBPACK FOOTER //
// src/components/pages/layouts/MmpHeader.vue